import { QueryNode } from "./query-node";

export interface SortOption<T> {
  field: keyof T;
  direction: "asc" | "desc";
}

/**
 * Base class for typed IndexedDB fetch requests.
 *
 * Supports chaining predicates.
 * Pass an instance to `BaseStorageService.fetch()`.
 */
export class Predicate<T> {
  readonly nodes: QueryNode<T>[] = [];

  /** @deprecated Use whereEq, whereIn, etc. for better performance. */
  where(predicate: (item: T) => boolean): this {
    this.nodes.push({ type: "custom", fn: predicate });
    return this;
  }

  whereEq<K extends keyof T>(field: K, value: T[K]): this {
    this.nodes.push({ type: "eq", field, value });
    return this;
  }

  whereCompoundEq(indexName: string, value: IDBValidKey[]): this {
    this.nodes.push({ type: "compound-eq", indexName, value });
    return this;
  }

  whereIn<K extends keyof T>(field: K, value: T[K][]): this {
    this.nodes.push({ type: "in", field, value });
    return this;
  }

  whereRange<K extends keyof T>(field: K, gte?: T[K], lte?: T[K]): this {
    this.nodes.push({ type: "range", field, gte, lte });
    return this;
  }

  whereContains<K extends keyof T>(field: K, value: string | number): this {
    this.nodes.push({ type: "contains", field, value });
    return this;
  }
}
